import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=2dbf2805&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=js&"
export * from "./AddUser.vue?vue&type=script&lang=js&"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=2dbf2805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf2805",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbf2805')) {
      api.createRecord('2dbf2805', component.options)
    } else {
      api.reload('2dbf2805', component.options)
    }
    module.hot.accept("./AddUser.vue?vue&type=template&id=2dbf2805&scoped=true&", function () {
      api.rerender('2dbf2805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Profile/Location/AddUser.vue"
export default component.exports